<tr *ngFor="let mapping of mappingData.mapping;">
  <td>{{mapping.parentData}}</td>
  <td>{{mapping.childData}}</td>
  <td ><i class="fa d-inline fa-lg fa-edit " (click)="editMappingData()" ></i> 
    <i class="fa d-inline fa-lg fa-trash-o" ></i></td>
</tr>